export const INITIAL_IMAGE_HASH_ARRAY = [
    '3a0a51a5', 'f65922f6', '484f470e', '0315ae5b', '7c41e106', '1adcd8fb',
    'd0c11aeb', '495bd6a3', 'c5b5cf7d', '274a09dc', '20034c7e', '21f776fb',
    '7807021c', '4f6b03a0', '91ea28cf', 'a3e7464d', 'bfd07545', '86b975f3'
]
